// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.actionBtn {
    font-size: 3em;
    cursor: pointer;
}
/* .snapshot {
    text-align: center;
}
.snapshot img {
    max-width: 800px;
    max-height: 800px;
} */
ul.links {
    padding-bottom: 20px;
}

::ng-deep video{
    width: 100%;
    height: 100%;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNhbWVyYS5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksY0FBYztJQUNkLGVBQWU7QUFDbkI7QUFDQTs7Ozs7O0dBTUc7QUFDSDtJQUNJLG9CQUFvQjtBQUN4Qjs7QUFFQTtJQUNJLFdBQVc7SUFDWCxZQUFZO0FBQ2hCIiwiZmlsZSI6ImNhbWVyYS5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmFjdGlvbkJ0biB7XHJcbiAgICBmb250LXNpemU6IDNlbTtcclxuICAgIGN1cnNvcjogcG9pbnRlcjtcclxufVxyXG4vKiAuc25hcHNob3Qge1xyXG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xyXG59XHJcbi5zbmFwc2hvdCBpbWcge1xyXG4gICAgbWF4LXdpZHRoOiA4MDBweDtcclxuICAgIG1heC1oZWlnaHQ6IDgwMHB4O1xyXG59ICovXHJcbnVsLmxpbmtzIHtcclxuICAgIHBhZGRpbmctYm90dG9tOiAyMHB4O1xyXG59XHJcblxyXG46Om5nLWRlZXAgdmlkZW97XHJcbiAgICB3aWR0aDogMTAwJTtcclxuICAgIGhlaWdodDogMTAwJTtcclxufSJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/camera/camera.component.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,eAAe;AACnB;AACA;;;;;;GAMG;AACH;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;AACA,gwBAAgwB","sourcesContent":[".actionBtn {\r\n    font-size: 3em;\r\n    cursor: pointer;\r\n}\r\n/* .snapshot {\r\n    text-align: center;\r\n}\r\n.snapshot img {\r\n    max-width: 800px;\r\n    max-height: 800px;\r\n} */\r\nul.links {\r\n    padding-bottom: 20px;\r\n}\r\n\r\n::ng-deep video{\r\n    width: 100%;\r\n    height: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
